<app-standard-data-table
    (gridRequested)="gridRequested($event)"
    [source]="assets"
    [columns]="columns$ | async"
    [selectionType]="SelectionType.single"
    (rowSelected)="emitSelect($event)"
    [noRecordsMessage]="noAssetRecords"
></app-standard-data-table>

<ng-template #deviceStatusTemplate let-row="row">
    <app-device-status class="device-and-asset-status-position" [status]="row?.deviceStatus"></app-device-status>
</ng-template>

<ng-template #configModeHeaderTemplate>
    @if (isConfigMode) {
        {{ 'assets.activated' | translation | async }}
    }
</ng-template>

<ng-template #nameTemplate let-value="value">
    <div class="text-truncate w-100 d-inline-block" [ngbTooltip]="value" tooltipClass="standard-tooltip">
        {{ value }}
    </div>
</ng-template>

<ng-template #configModeTemplate let-row="row">
    @if (isConfigMode) {
        <div class="form-check">
            <input class="form-check-input" type="checkbox" [checked]="row?.isActivated" id="ActivatedCheckbox{{ row?.id }}" (click)="$event.stopPropagation(); emitActivationChange(row)" />
        </div>
    }
</ng-template>

<ng-template #metadataTemplate let-row="row">
    @if ((row?.metadata ?? '').toString().trim() !== '') {
        <i class="fab fa-megaport fa-lg default-icon-color" placement="left" tooltipClass="standard-tooltip" [ngbTooltip]="assetMetadata"></i>
        <ng-template #assetMetadata>
            <div [innerHTML]="getAssetMetadata(row?.metadata)"></div>
        </ng-template>
    }
</ng-template>

<ng-template #commandsTemplate let-row="row">
    <a *appHasPermission="'asset.write'" [ngbTooltip]="'actions.edit' | translation | async" placement="left" (click)="emitEdit(row)">
        <span class="edit-icon default-icon-color"></span>
    </a>
</ng-template>

<ng-template #noAssetRecords>
    <div class="mx-auto mt-4 text-center default-icon-color">
        <i class="fas fa-info-circle fa-7x"></i>
        <div class="no-records-message">{{ 'assets.noRecordsMessage' | translation | async }}</div>
        <div class="no-records-message-detail">{{ 'assets.NoRecordsMessageDetail' | translation | async }}</div>
    </div>
</ng-template>
